import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const SET_RISK_PAYER_CASE_DETAIL_ID = "SET_RISK_PAYER_CASE_DETAIL_ID";

export const service = async (data) => {
  const options: object = {
    url: '/api/EaCaseApiController/SaveSelectedCaseDetailId',
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(SET_RISK_PAYER_CASE_DETAIL_ID, service, mock);
